import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=a4a2238a&scoped=true&"
import script from "./ProductList.ts?vue&type=script&lang=ts&"
export * from "./ProductList.ts?vue&type=script&lang=ts&"
import style0 from "./ProductList.vue?vue&type=style&index=0&id=a4a2238a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a2238a",
  null
  
)

export default component.exports